import axios from "./axios-handler.service";
const BASE_URL = "/api/Dashboard";

export interface Dashboard {
  faturamentoPeriodo: FaturamentoPeriodo[];
  mediaDia: number;
  planos: number;
  projetado: number;
  totalFaturado: number;
  totalTaxas: number;
}

export interface FaturamentoPeriodo {
  cet: number;
  liquido: number;
  meioPagamento: string;
  forma: string;
  taxas: number;
  total: number;
}

export interface FaturamentoDiario {
  data: string;
  qtd: number;
  qtdMesPassado: number;
  total: number;
  totalMesPassado: number;
}

export interface TotalAssinantes {
  data: string;
  gratis: number;
  lite: number;
  essencial: number;
  essencialconectada: number;
  superconectada: number;
  hiperconectada: number;
  totalpago: number;
  total: number;
}

export interface PrevisaoFaturamento {
  data: string;
  valorCartao: number;
  valorPagseguro: number;
  previstoCartao: number;
  previstoPagseguro: number;
}

export interface Cadastros {
  data: Date;
  quantidadeSite?: number;
  quantidadeApp?: number;
}

export interface CadastroAcumulado {
  data: string;
  totalEsteMes: number;
  totalMesPassado: number;
}

export interface Evento {
  idConsultor: number;
  nome: string;
  acao: string;
  dataCriacao: Date;
}

export interface Erro {
  data: Date;
  descricao: string;
  idConsultor: number;
  nome: string;
}

export interface Atendimento {
  idUsuario: number;
  aberto: number;
  primeiroNome: string;
}

export interface ListaFunil {
  oportunidades: number;
  primeiroContato: number;
  segundoContato: number;
  qualificadoAtendimento: number;
  ganhos: number;
  perdas: number;
}

export interface ListaAtendimento {
  geradoNoDia: number;
  data: Date;
  descricao: string;
  realizado: string;
}

export interface FaturamentoDetalhado {
  dataPagamento: string;
  tipoMeioPagamento: string;
  meioPagamento: string;
  total: number;
  recebidoEm: string;
}

export class DashboardService {
  static async mostrarFinanceiro(): Promise<boolean> {
    const response = await axios.get(`${BASE_URL}/MostrarFinanceiro`);
    return response.data;
  }

  static async financeiro(mesAno: string): Promise<Dashboard> {
    const response = await axios.get(`${BASE_URL}/Financeiro`, {
      params: { mesAno },
    });
    return response.data;
  }

  static async faturamentoDetalhado(
    mesAno: string
  ): Promise<FaturamentoDetalhado[]> {
    const resp = await axios.get<FaturamentoDetalhado[]>(
      `${BASE_URL}/FaturamentoDetalhado`,
      {
        params: { mesAno },
      }
    );
    return resp.data;
  }

  static async faturamentoDiario(mesAno: string): Promise<FaturamentoDiario[]> {
    const response = await axios.get(`${BASE_URL}/FaturamentoDiario`, {
      params: { mesAno },
    });
    return response.data;
  }

  static async previsaoFaturamento(
    mesAno: string
  ): Promise<PrevisaoFaturamento[]> {
    const response = await axios.get(`${BASE_URL}/PrevisaoFaturamento`, {
      params: { mesAno },
    });
    return response.data;
  }

  static async Planos(mesAno: string): Promise<any[]> {
    const response = await axios.get<any>(`${BASE_URL}/Planos`, {
      params: { mesAno },
    });
    return response.data;
  }

  static async Cadastros(mesAno: string): Promise<Cadastros[]> {
    const response = await axios.get<any>(`${BASE_URL}/Cadastros`, {
      params: { mesAno },
    });
    return response.data;
  }

  static async CadastroAcumulado(mesAno: string): Promise<CadastroAcumulado[]> {
    const response = await axios.get<any>(`${BASE_URL}/CadastroAcumulado`, {
      params: { mesAno },
    });
    return response.data;
  }

  static async ListaPlanos(data: string): Promise<string[]> {
    const response = await axios.get<any>(`${BASE_URL}/ListaPlanos`, {
      params: { data },
    });
    return response.data;
  }

  static async ListaAssinaturasExpiradas(data: string): Promise<string[]> {
    const response = await axios.get<any>(
      `${BASE_URL}/ListaAssinaturasExpiradas`,
      {
        params: { data },
      }
    );
    return response.data;
  }

  static async AssinaturasHoje(data: string): Promise<number> {
    const response = await axios.get<any>(`${BASE_URL}/AssinaturasHoje`, {
      params: { data },
    });
    return response.data;
  }

  static async PlanosExpirados(data: string, status: number): Promise<number> {
    const response = await axios.get<any>(`${BASE_URL}/PlanosExpirados`, {
      params: { data, status },
    });
    return response.data;
  }

  static async GratisExpirados(data: string): Promise<number> {
    const response = await axios.get<any>(`${BASE_URL}/GratisExpirados`, {
      params: { data },
    });
    return response.data;
  }

  static async obterAssinantesDeltaDiario(data: string): Promise<number> {
    const response = await axios.get<number>(
      `${BASE_URL}/ObterAssinantesDeltaDiario`,
      {
        params: { data },
      }
    );
    return response.data;
  }

  static async clientesQueNaoRenovaram(data: string): Promise<number> {
    const response = await axios.get<number>(
      `${BASE_URL}/ClientesQueNaoRenovaram`,
      {
        params: { data },
      }
    );
    return response.data;
  }

  static async QuantidadeErros(): Promise<number> {
    const response = await axios.get<any>(`${BASE_URL}/QuantidadeErros`);
    return response.data;
  }

  static async QuantidadeEventos(): Promise<number> {
    const response = await axios.get<any>(`${BASE_URL}/EventosErro`);
    return response.data;
  }

  static async QuantidadeProcessosEmFalha(): Promise<number> {
    const response = await axios.get<any>(`${BASE_URL}/ProcessosEmFalha`);
    return response.data;
  }

  static async ListaEventos(): Promise<Evento[]> {
    const response = await axios.get<any>(`${BASE_URL}/ListaEventos`);
    return response.data;
  }

  static async ListaErros(): Promise<Erro[]> {
    const response = await axios.get<any>(`${BASE_URL}/ListaErros`);
    return response.data;
  }

  static async ListaAtendimentosDashboard(
    data: string
  ): Promise<Atendimento[]> {
    const response = await axios.get<any>(
      `${BASE_URL}/ListaAtendimentosDashboard`,
      {
        params: { data },
      }
    );
    return response.data;
  }

  static async ListaFunil(data: string): Promise<ListaFunil> {
    const response = await axios.get<any>(`${BASE_URL}/ListaFunil`, {
      params: { data },
    });
    return response.data;
  }

  static async ListaAtendimento(data: string): Promise<ListaAtendimento[]> {
    const response = await axios.get<any>(`${BASE_URL}/ListaAtendimentosDia`, {
      params: { data },
    });
    return response.data;
  }

  static async TaxaDeConversaoDeLeads(data: string): Promise<number> {
    const response = await axios.get<any>(
      `${BASE_URL}/TaxaDeConversaoDeLeads`,
      {
        params: { mesAno: data },
      }
    );
    return response.data;
  }

  static async SairamMarketing(data: string): Promise<number> {
    const response = await axios.get<any>(`${BASE_URL}/SairamMarketing`, {
      params: { mesAno: data },
    });
    return response.data;
  }

  static async EntraramMarketing(data: string): Promise<number> {
    const response = await axios.get<any>(`${BASE_URL}/EntraramMarketing`, {
      params: { mesAno: data },
    });
    return response.data;
  }

  static async CadastrosMes(ano: string): Promise<Cadastros[]> {
    const response = await axios.get<any>(`${BASE_URL}/CadastrosMes`, {
      params: { ano },
    });
    return response.data;
  }
}
